import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "app-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_AppFilters = _resolveComponent("AppFilters")!
  const _component_AppToDo = _resolveComponent("AppToDo")!
  const _component_AppAddToDo = _resolveComponent("AppAddToDo")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppHeader),
    _createVNode(_component_AppFilters, {
      "active-filter": _ctx.activeFilter,
      onSetFilter: _ctx.setFilter
    }, null, 8, ["active-filter", "onSetFilter"]),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_AppToDo, {
        todos: _ctx.filterdTodos,
        onToggleTodo: _ctx.toggleTodo,
        onRemoveTodo: _ctx.removeTodo,
        onEditTodo: _ctx.editTodo
      }, null, 8, ["todos", "onToggleTodo", "onRemoveTodo", "onEditTodo"]),
      _createVNode(_component_AppAddToDo, { onAddTodo: _ctx.addToDo }, null, 8, ["onAddTodo"])
    ]),
    _createVNode(_component_AppFooter, { stats: _ctx.stats }, null, 8, ["stats"])
  ]))
}